import { useState, useEffect } from 'react';
import { debounce } from '@mui/material';

export const useDebounceValue = (value: any, delay = 300) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = debounce(() => {
            setDebouncedValue(value);
        }, delay);

        handler();

        return () => {
            handler.clear();
        };
    }, [value, delay]);

    return debouncedValue;
};
